import React from 'react';

const plans = ['BASIC', 'PRO', 'ENTERPRISE'];

const TenantPlanPanel = ({ tenant, onChangePlan, changingPlan }) => {
  const handleChange = async (plan) => {
    if (!tenant || String(tenant.plan) === String(plan)) return;
    if (!window.confirm(`Ubah paket tenant ${tenant.tenantName} ke ${plan}?`)) return;
    await onChangePlan({ tenantId: tenant.tenantId, plan });
  };

  return (
    <section className="rounded-xl border border-slate-800 bg-slate-900/70 p-4">
      <h3 className="text-sm font-semibold text-slate-100">Ubah Paket</h3>
      <div className="mt-2 text-xs text-slate-400">Paket aktif: {tenant?.plan || '-'}</div>
      <div className="mt-3 flex flex-wrap gap-2">
        {plans.map((plan) => (
          <button
            key={plan}
            type="button"
            disabled={changingPlan || !tenant}
            onClick={() => handleChange(plan)}
            className={`rounded-md border px-3 py-1.5 text-xs ${tenant?.plan === plan ? 'border-cyan-500/50 bg-cyan-500/10 text-cyan-100' : 'border-slate-700 bg-slate-950 text-slate-200'}`}
          >
            {plan}
          </button>
        ))}
      </div>
    </section>
  );
};

export default TenantPlanPanel;
